<template>
	<div>
		<loader-component v-if="loading" :loader-message="'Fetching Market Data'"></loader-component>

		<div v-if="error" class="tx-center tx-danger">
			{{ error }}
		</div>
		<div v-else>
			<div v-if="isSummary" class="col-12">
				<trade-summary-component :trade="form" @submit-request="submitRequest('process')" @cancel-request="cancelRequest" />
			</div>
			<div v-else class="mt-3">
				<div v-if="isEmpty(fixedIncomeAvailable)">
					<h5 class="tx-color-01 mg-b-5 tx-center">Empty.</h5>
					<p class="tx-color-03 tx-13 tx-center">No Fixed Income available at the moment.</p>
				</div>
				<div v-else>
					<trade-cash-balance-component :currency="'GHS'" />
					<alert-success v-if="submitted" :form="form" :class="'shadow-sm'" message="Fixed Income trade created successfully."></alert-success>

					<fixed-income-trade-counter-component
						v-if="showTradeCounter"
						:form="form"
						:loading-counter="loadingTradeCounterData"
						@remove-fixed-income="removeFixedIncome"
						@update-counter-status="updateloadingTradeCounterStatus"
						@remove-all="removeAll"
						@validate-request="validateFixedIncomeRequest"
					/>
					<fixed-income-trade-data-compoonent :fixed-income-available="fixedIncomeAvailable" @select-fixed-income="selectFixedIncome" />
				</div>
			</div>
		</div>
	</div>
</template>

<style>
@media (min-width: 992px) {
	#fixed-income-request {
		top: 103px;
		z-index: 1;
	}
}
</style>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { trade } from '../../../../mixins';

export default {
	mixins: [trade.equities],
	mounted() {
		this.fetchData();
	},
	data() {
		return {
			error: null,
			loading: false,
			isSummary: false,
			submitted: false,
			showTradeCounter: false,
			loadingTradeCounterData: false,
			portfolio: {},
			fixedIncomeAvailable: [],
			form: new Form({
				type: 'fixed-income',
				action: 'validate',
				portfolio_id: null,
				cash_balance: {},
				trade_data: [],
			}),
		};
	},
	computed: {
		...mapGetters({
			cash_balance: 'trade/cashBalance',
			user: 'user',
			company: 'company',
		}),
	},
	methods: {
		selectFixedIncome(isin) {
			this.fixedIncomeAvailable.some((data) => {
				if (data.security_isin === isin && !data.selected) {
					this.form.clear();
					this.showTradeCounter = true;
					const { external_portfolio_id } = this.portfolio;

					this.form.trade_data.push({
						external_portfolio_id,
						fixed_income: {
							security_isin: data.security_isin,
							security_details: data.security_details,
							min_trade_amount: data.min_trade_amount,
							type: data.type,
						},
						type: 'BUY',
						volume: null,
						maturity: null,
						market_type: 'GSE',
					});

					return true;
				}
			});
		},
		removeFixedIncome({ isin, index }) {
			this.form.trade_data.splice(index, 1);
			this.showTradeCounter = !_.isEmpty(this.form.trade_data);
			this.deselectFixedIncome(isin);
		},
		removeAll() {
			this.form.trade_data.forEach((fixedIncome) => {
				this.deselectFixedIncome(fixedIncome.security_isin);
			});

			this.form.trade_data = [];
		},
		deselectFixedIncome(isin) {
			this.fixedIncomeAvailable.some((datum) => {
				if (datum.security_isin === isin) {
					datum.selected = false;
					return true;
				}
			});
		},
		updateloadingTradeCounterStatus(status) {
			this.showTradeCounter = status;
		},
		validateFixedIncomeRequest() {
			this.submitRequest('validate');
		},
		fetchPortfolio() {
			return axios.get(`/api/companies/${this.company.external_client_id}/portfolios`, {
				params: {
					portfolio_type_id: 1,
					noAllocation: true,
				},
			});
		},
		fetchFixedIncomeAvailable(external_client_id) {
			return axios.get('/api/fixed-income', {
				params: {
					external_client_id,
				},
			});
		},
		fetchData() {
			const { external_client_id } = this.company;

			axios
				.all([this.fetchPortfolio(), this.fetchFixedIncomeAvailable(external_client_id)])
				.then(
					axios.spread((portfolioResponse, fixedIncomeAvailableResponse) => {
						const portfolio = portfolioResponse.data.data.portfolio;

						this.portfolio = portfolio;
						this.fixedIncomeAvailable = fixedIncomeAvailableResponse.data.data.fixed_income;
						this.form.cash_balance = this.cash_balance;
						this.form.portfolio_id = portfolio.external_portfolio_id;
					})
				)
				.catch((error) => {
					this.error = error.toString();
				})
				.finally(() => {
					this.message = null;
					this.loading = false;
				});
		},
		cancelRequest() {
			this.form.action = 'validate';
			this.isSummary = false;
		},
		submitRequest(type) {
			this.form.action = type;
			this.submitted = null;

			this.form
				.post('/api/trade')
				.then(({ data: { data } }) => {
					if (type === 'process') {
						this.submitted = true;
						this.isSummary = false;

						return this.removeAll();
					}

					this.isSummary = true;
				})
				.catch(() => {
					this.error = this.form.errors.get('error');
				});
		},
	},
};
</script>

<style>
</style>